import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { PageHeader, ReportModal, ArchivedReportCard, Overlay } from "../../../../Components";
import { frames } from "../../../../Styles";
import { Pages } from "../../../../Navigation/root";
import CardsView from "../../../../Assets/TestData/cardsView";
import { ReportTemplate } from "../../../../Definitions/valueTypes";
import TemplateModal from "../../../../Components/Reports/Modals/templateModal";
import { useAppSelector } from "../../../../Store";
import { Graph_QL } from "../../../../Services";
import { useReportTemplate } from "../../../../Services/Agrisys_GqlDataCaller/ReportDataCalls/useReportTemplate";

export default function Reports() {
  const {t} = useTranslation()
  const [selectedTemplate, setSelectedTemplate] = useState<ReportTemplate | undefined>(undefined)
  const [reportModal, setReportModal] = useState<boolean>(false)
  const [templateModal, setTemplateModal] = useState<boolean>(false)
  const [copyTemplateMode, setCopyTemplateMode] = useState(false)

  const farm = useAppSelector(({ activeData }) => activeData.farm) ?? "";
  const domain = useMemo(() => Graph_QL.ObjToString({ domain: farm }), [farm]);
  const connection = useMemo(() => Graph_QL.create({ domain: farm }), [farm]);
  
  const {call: getTemplates, data: templateState} = useReportTemplate(connection);

  useEffect(() => {
    getTemplates({fetchAmount: 50, offset: 0});
  },[getTemplates])
  
  const templates = useMemo(() => {
    if (templateState && templateState[domain]) {
      return templateState[domain].data
    }
    return [];
  },[domain, templateState])

  return (
    <frames.Page_inner>
      <PageHeader
        topHeader={t(`menuHeaders.${Pages.reports}`, { defaultValue: "reports" })}
        subHeader={t("menuHeaders.overview", { defaultValue: "overview" })}
        optionButtons={{
          contents: copyTemplateMode ? [t("buttons.cancel", {defaultValue: "cancel"})] : [t("reportPages.reports.addTemplate", {defaultValue: "add template"}), t("reportPages.reports.copyTemplate", {defaultValue: "copy template"})],
          onClick: copyTemplateMode ? (i => { 
            if (i === 0) {setCopyTemplateMode(false)}
          }) : (i => { 
            if (i === 0) {setTemplateModal(true)}
            else if (i === 1) {setCopyTemplateMode(true)}
          })
        }}
      />
      <frames._page_inner_content>
        <frames._page_inner_content_scroll>
          {copyTemplateMode ? <Overlay overrides={{zIndex: 9999}}/> : <></>}
          <div style={{position: copyTemplateMode? "relative" : "unset"}}>
            <CardsView
              items={templates.map((item, index) => (
                <ArchivedReportCard key={index} template={item} onCardSelect={(id) => { setSelectedTemplate(templates.find(template => template.templateId === id)); copyTemplateMode ? setTemplateModal(true) : setReportModal(true)}} />
              ))}
              cardBtn={{
                content: t("reportPages.reports.createReport", { defaultValue: "Create Report" }),
                subContent: t("reportPages.reports.createNewReport", { defaultValue: "Start a new report from scratch" }),
                onCardBtnClick: () => setReportModal(true)
              }}
            />
          </div>
        </frames._page_inner_content_scroll>
      </frames._page_inner_content>

      <ReportModal 
        isModalOpen={reportModal}
        closeModal={() => { setReportModal(false); setSelectedTemplate(undefined)}}
        template={selectedTemplate}
      />
      
      <TemplateModal
        isModalOpen={templateModal}
        closeModal={() => { setTemplateModal(false); setSelectedTemplate(undefined) }}
        template={selectedTemplate}
      />

    </frames.Page_inner>
  )
}